<template>
  <div class="switch">
    <span
      @click="switchOption(0)"
      :class="[
        'switch-label switch-label--off',
        switchEnabled == 0 ? 'switch-label--enabled' : '',
        options[0].title.length > 10 ? 'switch-label--small' : ''
      ]"
      v-html="options[0].title"
    ></span>
    <span
      @click="switchOption(1)"
      :class="[
        'switch-label switch-label--on',
        switchEnabled == 1 ? 'switch-label--enabled' : '',
        options[1].title.length > 10 ? 'switch-label--small' : ''
      ]"
      v-html="options[1].title"
    ></span>
    <switches
      v-model="switchEnabled"
      theme="custom"
      color="blue"
      @input="onChange"
    />
  </div>
</template>

<script>
import Switches from "vue-switches";

export default {
  components: {
    Switches
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    result: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      selectedOption: this.result ? this.result : this.options[1]
    };
  },
  computed: {
    switchEnabled: {
      get() {
        return this.options.indexOf(this.selectedOption) == 1;
      },
      set() {
        this.switchOption();
      }
    }
  },
  beforeMount() {
    if (this.options.length != 2) {
      // eslint-disable-next-line no-console
      console.error("Switch options props must be an array of length 2.");
    }
  },
  mounted() {
    //this.switchOption(0);
    this.onChange();
  },
  methods: {
    switchOption(toggleIndex) {
      this.selectedOption = this.options[
        toggleIndex != null
          ? toggleIndex
          : Math.abs(this.options.indexOf(this.selectedOption) - 1)
      ];
    },
    onChange() {
      this.$emit("change", this.selectedOption);
    }
  }
};
</script>

<style lang="scss" scoped>
.switch {
  display: flex;
  align-items: center;
  justify-content: center;
}

.switch-label {
  font-size: 20px;
  margin: 0 15px;
  text-transform: uppercase;
  color: $c-switch-background;
  user-select: none;
  cursor: pointer;
  transition: color $s-transition, transform 1s $s-transition-easing-bounce;
  flex: 0 1 50%;

  @include media(">=tablet") {
    font-size: 33px;
    margin: 0 30px;
  }

  &:hover {
    color: $c-primary;

    & ~ .vue-switcher div::aftrer {
      left: 0;
    }
  }

  &--enabled {
    color: $c-primary;
  }

  &--on {
    order: 999;

    &.switch-label--enabled {
      transform: translateX(15px);
    }
  }

  &--off {
    text-align: right;

    &.switch-label--enabled {
      transform: translateX(-15px);
    }
  }

  &--small {
    font-size: 12px;

    @include media(">=tablet") {
      font-size: 22px;
    }
  }
}
</style>

<style lang="scss">
.switch {
  .vue-switcher-theme--custom {
    div {
      width: 120px;
      height: 41px;
      max-width: 100%;
      border-radius: 20px;
      box-shadow: inset 0px 3px 7px 0px rgba(0, 0, 0, 0.2);

      &::after {
        width: 46px;
        height: 46px;
        margin-left: -38px;
      }

      @include media(">=tablet") {
        width: 390px;
        height: 50px;

        &::after {
          width: 60px;
          height: 60px;
          margin-left: -40px;
        }
      }
    }
    &.vue-switcher-color--blue {
      div {
        background-color: $c-switch-background;

        &:after {
          // for the circle on the switch
          background-color: $c-primary;
        }
      }
    }
  }
}
</style>
